/**
 * Hook per rilevare il breakpoint corrente e se siamo su mobile.
 *
 * Usa le media query di Ant Design (md = 768px) per allinearsi ai
 * breakpoint della libreria UI e ottenere un comportamento coerente.
 */
import { Grid } from 'antd'

const { useBreakpoint } = Grid

/**
 * Ritorna true se lo schermo è ≤ md (768px), false altrimenti.
 * Utile per decidere tra layout desktop (sidebar fissa, tabelle)
 * e layout mobile (drawer, card).
 */
export function useIsMobile(): boolean {
  const screens = useBreakpoint()
  // Se md è attivo, significa schermo ≥ 768px → desktop
  return !screens.md
}

/**
 * Espone direttamente i breakpoint di AntD per casi più complessi.
 */
export { useBreakpoint }
